
import { Component, Vue, Prop} from 'vue-property-decorator';
import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";

import CmQuestionnaire from "./CmQuestionnaire.vue";
import OtherPersons from "./OtherPersons.vue";
import WithoutNoticeOrAttendance from "./WithoutNoticeOrAttendance.vue";
import ByConsent from "./ByConsent.vue";
import CmNotice from "./CmNotice.vue";
import Scheduling from "./Scheduling.vue";
import AboutCaseManagementOrder from "./AboutCaseManagementOrder.vue";
import CmChildrenInfo from "./childInfo/CmChildrenInfo.vue";
import ApplicationUnderFoaeaa from "./ApplicationUnderFOAEAA.vue";
import AttendanceUsingElectronicCommunication from "./AttendanceUsingElectronicCommunication.vue";
import ChangingOrCancellingAServiceOrNotice from "./ChangingOrCancellingAServiceOrNotice.vue";
import ChangingOrCancellingAnyOtherRequirement from "./ChangingOrCancellingAnyOtherRequirement.vue";
import RequiringAccessToInformation from "./RequiringAccessToInformation.vue";
import RecognizingAnOrderFromOutsideBc from "./RecognizingAnOrderFromOutsideBc.vue"
import ContactInformationOtherParty from "./ContactInformationOtherParty.vue"

import ReviewYourAnswersCm from "./reviewCM/ReviewYourAnswersCM.vue";
import PreviewForm10Cm from "./reviewCM/PreviewForm10CM.vue";
import PreviewForm11Cm from "./reviewCM/PreviewForm11CM.vue";

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

@Component({
    components:{
        StepBase,

        CmQuestionnaire,
        OtherPersons,        
        WithoutNoticeOrAttendance,
        ByConsent,
        CmNotice,
        Scheduling,
        AboutCaseManagementOrder,
        CmChildrenInfo,
        AttendanceUsingElectronicCommunication,
        ChangingOrCancellingAServiceOrNotice,
        ChangingOrCancellingAnyOtherRequirement,
        RequiringAccessToInformation,
        RecognizingAnOrderFromOutsideBc,
        ContactInformationOtherParty,
        ApplicationUnderFoaeaa,
        ReviewYourAnswersCm,
        PreviewForm10Cm,
        PreviewForm11Cm
    }
})
export default class CaseManagementStep extends Vue {
  
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;
}
